// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3a-0 {\n  height: 100%;\n  width: 100%;\n}\n\n._3a-1 {\n}\n\n._3a-2 {\n}\n\n._3a-3 > div {\n  background-color: var(--redo-colors-background-bg-primary_hover) !important;\n}\n\n._3a-3:hover > div {\n  background-color: var(--redo-colors-background-bg-primary_hover) !important;\n}\n", ""]);
// Exports
export var checkboxCell = "_3a-0";
export var hasRowsSelected = "_3a-1";
export var selectableTable = "_3a-2";
export var orangeSelectedRow = "_3a-3";
export default ___CSS_LOADER_EXPORT___;
